import { render, staticRenderFns } from "./newActivity.vue?vue&type=template&id=602808b8&scoped=true"
import script from "./newActivity.vue?vue&type=script&lang=js"
export * from "./newActivity.vue?vue&type=script&lang=js"
import style0 from "./newActivity.vue?vue&type=style&index=0&id=602808b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602808b8",
  null
  
)

export default component.exports